import * as t from "io-ts";
import { option } from "fp-ts/lib";
import { task } from "fp-ts/lib";
import * as fetchWrapper from "./fetch";
import { getApiUrl } from "./apiUrl";
import * as JsonResponse1 from "../../../domain/models/JsonResponse1";
import * as FirstPartyFetchResponse from "../../../domain/models/FirstPartyFetchResponse";

const buildUrl = (path: string): string =>
    path.startsWith("http") ? path : `${getApiUrl()}${path}`;

export const getJson = <D extends t.Any>(params: {
    url: string;
    dataCodec: D;
    defaultData: t.TypeOf<D>;
}): task.Task<FirstPartyFetchResponse.T<JsonResponse1.T<t.TypeOf<D>, {}>>> =>
    fetchWrapper.json({
        requestParams: {
            url: buildUrl(params.url),
            method: "GET",
            body: option.none,
        },
        expectedTypeCodec: JsonResponse1.createCodec(params.dataCodec, t.type({})),
        defaultResponse: { data: params.defaultData, meta: {} },
    });

export const postJson = <D extends t.Any>(params: {
    url: string;
    body: Record<string, unknown>;
    dataCodec: D;
    defaultData: t.TypeOf<D>;
}): task.Task<FirstPartyFetchResponse.T<JsonResponse1.T<t.TypeOf<D>, {}>>> =>
    fetchWrapper.json({
        requestParams: {
            url: buildUrl(params.url),
            method: "POST",
            body: option.some(JSON.stringify(params.body)),
        },
        expectedTypeCodec: JsonResponse1.createCodec(params.dataCodec, t.type({})),
        defaultResponse: { data: params.defaultData, meta: {} },
    });
